const UTILS = {
  async AddItemsToCart(items_to_add) {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items_to_add })
    })
  },
  GetUniqId() {
    return '_' + Math.random().toString(36).substr(2, 9);
  },
  async GetCart() {
    return await fetch('/cart.js').then(res => res.json())
  },
  UpdateCart(updates) {
    if (!updates) {
      return;
    }
    
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    });
  },
  RefreshCart() {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'))
  },
  FormatMoney(value) {
    return theme.Currency.formatMoney(value, theme.settings.moneyFormat)
  }
};

document.addEventListener('alpine:init', () => {
  (() => {
    const PRODUCT_TYPE_ADDON = 'Addon_'
    const PROP_KEY = '__u_id'

    Alpine.data('RingSize', () => ({
      cache: {},
      size_v_id: '',
      size_prod: null,
      main_variant: null,
      size_variant: null,
      uniq_id: '',
      init() {
        let am = this;
        am.InitSelf()
      },
      InitSelf() {
        let am = this;
        am.$el.classList.remove('visually-hidden')

        am.size_v_id = am.$el.dataset.size_v_id
        am.size_prod = JSON.parse(am.$el.dataset.size_prod)
        am.main_variant = JSON.parse(am.$el.dataset.main_variant)

        am.cache.$section = am.$el
        am.cache.$product_meta = am.$el.closest('.product-single__meta')

        am.SetSelectedVariant()
        am.$watch('size_v_id', am.SetSelectedVariant.bind(am))

        am.InitEventHandlers()
      },
      SetSelectedVariant() {
        let am = this;
        am.size_variant = am.size_prod.variants.find(v => v.id == am.size_v_id)
        am.uniq_id = UTILS.GetUniqId()
        am.UpdatePrice()
      },
      InitEventHandlers() {
        let am = this;
        document.addEventListener('variant:change', (e) => {
          am.main_variant = e.detail.variant
          am.UpdatePrice()
        })
      },
      UpdatePrice() {
        let am = this;
        let $price = am.cache.$product_meta.querySelector('.product-block--price [data-product-price]')
        if (!$price) return;

        let total_price = am.main_variant.price + am.size_variant.price
        $price.textContent = UTILS.FormatMoney(total_price)
      },
      e_SelectSize(e, size_v_id) {
        let am = this;
        am.size_v_id = size_v_id
        UIkit.dropdown(am.cache.$section.querySelector('.size-dd')).hide()
      }
    }));

    Alpine.data('Engraving', () => ({
      chars_remaining: 80,
      message: '',
      uniq_id: UTILS.GetUniqId(),

      fonts: [
        { name: 'Times New Roman', selected: false, fontFamily: 'Times New Roman' },
        { name: 'Arial', selected: false, fontFamily: 'Arial' },
        // { name: 'Olde English', selected: false, fontFamily: 'Olde English' },
        // { name: 'LinLibertine R', selected: false, fontFamily: 'LinLibertine_R' },
        { name: 'Magnolia Script', selected: false, fontFamily: 'Magnolia Script' },
        { name: 'Gabrielle', selected: false, fontFamily: 'Gabrielle' },
        { name: 'Old English', selected: false, fontFamily: 'Old English' }
      ],
      init() {
        let am = this;
        am.InitSelf()

        am.$watch('message', () => {
          am.chars_remaining = 80 - am.message.length
        })
      },
      InitSelf() {
        let am = this;
        am.cache.$section = am.$el
        am.$el.classList.remove('visually-hidden')
      },
      GetSelectedFont() {
        let am = this;
        return am.fonts.find(font => font.selected)
      },
      e_GetMessage(e) {
        let am = this;
        am.message = e.target.value
      },
      e_SelectFont(e, font) {
        let am = this;
        am.fonts.forEach((font) => {
          font.selected = false
        });
        font.selected = true;
        UIkit.dropdown(am.cache.$section.querySelector('.fonts-dd')).hide()
      }
    }));

    Alpine.data('ProductFormCustomOptions', () => ({
      uniq_id: UTILS.GetUniqId(),
      cache: {},
      init() {
        let am = this;
        am.InitSelf()
      },
      InitSelf() {
        let am = this;

        am.cache.$section = am.$el
        am.cache.$form = am.$el.closest('.product-single__form')

        am.InitEventHandlers()
      },
      InitEventHandlers() {
        let am = this;
        am.cache.$form.addEventListener('ajaxProduct:added', (e) => {
          let is_mainProduct = e.detail.product
          if (!is_mainProduct) return;

          // addon variants
          let $addons = am.$el.querySelectorAll('[data-variant]')
          if (!$addons.length) return;
          let items_to_add = [...$addons].map(($item) => {
            return {
              id: $item.value,
              quantity: 1,
              properties: {
                '__u_id': am.uniq_id
              }
            };
          });

          (async() => {
            await UTILS.AddItemsToCart(items_to_add)
            UTILS.RefreshCart()
            am.uniq_id = UTILS.GetUniqId()
          })()
        })
      }
    }))

    Alpine.data('CartLineItem', () => ({
      cart: null,
      line_item: null,
      addon_items: [],
      __u_id: '',
      flags: {
        is_addon: false,
        is_main: false,
        has_size_attached: false
      },
      init() {
        let am = this;
        am.InitSelf()
      },
      async InitSelf() {
        let am = this;
        am.cart = await UTILS.GetCart()
        am.line_item = am.cart.items.find(item => item.key == am.$el.dataset.key)

        if (!am.line_item) return;

        let product_type = am.line_item.product_type
        am.flags.is_addon = product_type.indexOf('Addon') !== -1
        am.flags.is_main = product_type.indexOf('Addon_') == -1

        am.flags.has_size_attached = am.flags.is_main && am.line_item.properties[PROP_KEY] !== undefined
        if (am.flags.is_addon || am.flags.is_main) {
          am.__u_id = am.line_item.properties[PROP_KEY]
        }

        am.addon_items = am.cart.items.filter(item => item.properties[PROP_KEY] == am.__u_id && item.product_type.indexOf('Addon_') !== -1)

        am.SyncQuantity()
        am.UpdatePrice()
      },
      SyncQuantity() {
        // Update quantity of Addons to sync with main variant quantity
        let am = this;
        if (am.flags.is_addon) {
          let main_variant = am.cart.items.find(item => {
            return item.product_type.indexOf('Addon_') == -1 && am.__u_id == item.properties[PROP_KEY]
          })

          let updates = {};
          if (!main_variant) {
            updates[am.line_item.id] = 0
          }
          else if(main_variant.quantity !== am.line_item.quantity) {
            updates[am.line_item.id] = main_variant.quantity
          }

          if (JSON.stringify(updates) !== '{}') {
            UTILS.UpdateCart(updates).then(UTILS.RefreshCart)
          }      
        }
      },
      UpdatePrice() {
        let am = this;
        // Show price + ring variant price
        if (am.flags.is_main) {
          let addons_total = am.addon_items.reduce((sum, item) => {
            return sum + item.final_price
          }, 0)
          let item_total = am.line_item.final_price + addons_total
          let $price = am.$el.querySelector('.cart__price')
          if ($price) {
            $price.textContent = UTILS.FormatMoney(item_total)
          }
        }
      }
    }));
  })()
})